// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "bundle.23adebd06a721566387d5d50583be19f.css";
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "c4d0e9e8432ffa268531f4acadbd8d88" + ".css";
};